import {
    trigger,
    transition,
    style,
    query,
    animate,
    group
} from '@angular/animations';

export const slideAnimation = trigger('routeAnimations', [
    transition(':increment', [
        style({ position: 'relative', minHeight: '100vh' }),
        query(':enter, :leave', [
            style({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            })
        ], { optional: true }),
        query(':enter', [
            style({ transform: 'translateX(100%)', opacity: 0 })
        ], { optional: true }),
        group([
            query(':leave', [
                animate('350ms ease-out', style({ transform: 'translateX(-100%)', opacity: 0 }))
            ], { optional: true }),
            query(':enter', [
                animate('350ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
            ], { optional: true })
        ])
    ]),
    transition(':decrement', [
        style({ position: 'relative', minHeight: '100vh' }),
        query(':enter, :leave', [
            style({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            })
        ], { optional: true }),
        query(':enter', [
            style({ transform: 'translateX(-100%)', opacity: 0 })
        ], { optional: true }),
        group([
            query(':leave', [
                animate('350ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
            ], { optional: true }),
            query(':enter', [
                animate('350ms ease-out', style({ transform: 'translateX(0%)', opacity: 1 }))
            ], { optional: true })
        ])
    ]),
    transition('* <=> *', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
            style({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%'
            })
        ], { optional: true }),
        query(':enter', [
            style({ opacity: 0 })
        ], { optional: true }),
        group([
            query(':leave', [
                animate('200ms ease-in', style({ opacity: 0 }))
            ], { optional: true }),
            query(':enter', [
                animate('300ms ease-out', style({ opacity: 1 }))
            ], { optional: true })
        ])
    ])
]);
